export const LS_AUTH_TOKEN = 'cooltix-translate-auth-token';
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export const UserRole = {
  ADMIN: 'ADMIN',
  EDITOR: 'EDITOR'
};
